import type {Theme, Components} from "../..";

type FormHelperTextOverrides = Components<Theme>["MuiFormHelperText"];

const overrides: FormHelperTextOverrides = {
    styleOverrides: {
        root: ({theme}) => ({
            ...theme.typography.body4,
            color: theme.color.text.subtlest,
            fontWeight: theme.typography.fontWeight.medium,

            "&.Mui-error": {
                color: theme.color.text.critical,
            },
        }),
    },
};

export default overrides;
